import {
  getCurrentJourneyWidgetPage,
  type JourneyWidgetPageState,
} from './pageState';

/**
 * UI-only selectors for JourneyWidgetTabs page state.
 *
 * Keep presentation rules here so the page-state reducer remains
 * domain/navigation focused.
 */

/**
 * Top-level tabs are hidden while viewing any details page.
 */
export function shouldShowTopLevelTabs(state: JourneyWidgetPageState): boolean {
  return getCurrentJourneyWidgetPage(state).kind !== 'details';
}

/**
 * Results and details pages are capped to the widget max height and scroll
 * inside it. Search pages grow with their content.
 */
export function shouldCapWidgetHeight(state: JourneyWidgetPageState): boolean {
  return getCurrentJourneyWidgetPage(state).kind !== 'search';
}

/**
 * Footer links are shown only on search pages.
 */
export function shouldShowFooter(state: JourneyWidgetPageState): boolean {
  return getCurrentJourneyWidgetPage(state).kind === 'search';
}
